/*! dataTables.pageLoadMore.js 1.0.1
 *  Copyright (c) Gyrocode LLC (www.gyrocode.com)
 *  License: MIT License
 */
/**
 * @summary     Allows to load more content with "Load More" button
 * @version     1.0.1
 * @file        dataTables.pageLoadMore.js
 * @author      [Gyrocode LLC](http://www.gyrocode.com/articles/jquery-datatables-pagination-with-load-more-button/)
 * @contact     https://www.gyrocode.com/contacts/
 * @copyright   Copyright (c) Gyrocode LLC
 * @license     MIT License
 */

let pageLoadMoreInit = (function($) {

//
// Loads only portion of the data
//
$.fn.dataTable.pageLoadMore = function(opts){
   // Configuration options
   var conf = $.extend({
       url: '',      // script url
       data: null,   // function or object with parameters to send to the server
                     // matching how `ajax.data` works in DataTables
       method: 'GET' // Ajax HTTP method
   }, opts);

   var cacheLastRequest = null;
   var cacheLastJson = null;
   var additional_data = {};

   return function (request, drawCallback, settings){
      conf.data(additional_data);
      if(!settings.pageLoadMore){
         var api = new $.fn.dataTable.Api(settings);
         var info = api.page.info();

         settings.pageLoadMore = { pageLength: info.length };
      }

      var pageResetMore = false;
      var changes = {
         order: false,
         columns: false,
         search: false,
         dates: false
      };

      if(cacheLastRequest){
         changes = {
            order: JSON.stringify(request.order) !== JSON.stringify(cacheLastRequest.order),
            columns: JSON.stringify(request.columns) !== JSON.stringify(cacheLastRequest.columns),
            search: JSON.stringify(request.search) !== JSON.stringify(cacheLastRequest.search),
            dates: cacheLastRequest.dates !== undefined && (JSON.stringify(additional_data.dates) !== JSON.stringify(cacheLastRequest.dates))
         };
         if( changes.order ||
             changes.columns ||
             changes.search ||
             changes.dates ||
             settings.pageLoadMore.forcedDropCache
         ){
            pageResetMore = true;
         }
         settings.pageLoadMore.forcedDropCache = false;
      }

      // Provide the same `data` options as DataTables.
      if($.isFunction (conf.data)){
         // As a function it is executed with the data object as an arg
         // for manipulation. If an object is returned, it is used as the
         // data object to submit
         var d = conf.data(request);
         if(d){
            $.extend(request, d);
         }
      } else if($.isPlainObject(conf.data)){
         // As an object, the data given extends the default
         $.extend(request, conf.data);
      }

      // Store the request for checking next time around
      cacheLastRequest = $.extend(true, {}, request);

      if(pageResetMore){
         cacheLastJson = null;
         if (changes.columns || changes.search || changes.dates || settings.pageLoadMore.forcedDropCache) {
            request.length = settings.pageLoadMore.pageLength;
         }
      }

      if (changes.order && !changes.columns && !changes.search && !changes.dates && !settings.pageLoadMore.forcedDropCache) {
         request.start = 0;
      } else {
         request.start = request.length - settings.pageLoadMore.pageLength;
         request.length = settings.pageLoadMore.pageLength;
      }

      settings.jqXHR = $.ajax({
         "type":     conf.method,
         "url":      conf.url,
         "data":     request,
         "dataType": "json",
         "cache":    false,
         "success":  function(json){
            if(cacheLastJson){
               json.data = cacheLastJson.data.concat(json.data);
            }

            cacheLastJson = $.extend(true, {}, json);

            drawCallback(json);
         }
      });
   };
};


//
// Resets page length to initial value on the next draw
//
$.fn.dataTable.Api.register('page.resetMore()', function(){
   return this.iterator('table', function (settings){
      var api = this;

      settings.pageLoadMore.forcedDropCache = true;
      api.page.len(settings.pageLoadMore.pageLength);
   });
});


//
// Determines whether there is more data available
//
$.fn.dataTable.Api.register('page.hasMore()', function(){
   var api = this;
   var info = api.page.info();
   return (info.pages > 1) ? true : false;
});


//
// Loads more data
//
$.fn.dataTable.Api.register('page.loadMore()', function(pageSize){
   return this.iterator('table', function (settings){
      var api = this;
      var info = api.page.info();

      if(info.pages > 1){
         if(!settings.pageLoadMore){
            settings.pageLoadMore = { pageLength: info.length };
         }
         if(!pageSize){
            pageSize = settings.pageLoadMore.pageLength;
         }else if(pageSize !== settings.pageLoadMore.pageLength){
            settings.pageLoadMore.pageLength = pageSize;
         }
         api.page.len(info.length + settings.pageLoadMore.pageLength).draw('page');
      }
   });
});

})(jQuery);

export default pageLoadMoreInit